import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "loading-animation" };
import spinNavy from "./spin.json";
import spinWhite from "./spin-white.json";
import checkMarkNavy from "./check-mark.json";
import checkMarkWhite from "./check-mark-white.json";
import { Vue3Lottie } from "vue3-lottie";
export default /*#__PURE__*/ _defineComponent({
    __name: 'LoadingAnimation',
    props: {
        showLoadingAnimation: { type: Boolean },
        showSuccessAnimation: { type: Boolean },
        color: { default: "navy" }
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_ctx.showLoadingAnimation)
                    ? (_openBlock(), _createBlock(_unref(Vue3Lottie), {
                        key: 0,
                        "animation-data": _ctx.color === 'white' ? _unref(spinWhite) : _unref(spinNavy),
                        height: '16px',
                        width: '16px'
                    }, null, 8 /* PROPS */, ["animation-data"]))
                    : _createCommentVNode("v-if", true),
                (_ctx.showSuccessAnimation)
                    ? (_openBlock(), _createBlock(_unref(Vue3Lottie), {
                        key: 1,
                        loop: 1,
                        "animation-data": _ctx.color === 'white' ? _unref(checkMarkWhite) : _unref(checkMarkNavy),
                        height: '16px',
                        width: '16px'
                    }, null, 8 /* PROPS */, ["animation-data"]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
